<template>
  <BaseModal :title="'Recording destination'" minHeight="250px" hook-sufix="LiveFolderModal">
    <template #content>
      <p>
        {{ $t('message.pages.live.chooseFolder') }}
      </p>

      <!-- breadcrumb -->
      <template v-if="!isNamesTooBig">
        <v-menu offset-y max-width="250">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" icon v-bind="attrs" v-on="on">
              <v-icon class="elevation-0" color="primary">
                mdi-package-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in reducedBreadcrumbArray" :key="index" @click="handleBackTo(item)" dense>
              <v-list-item-title :title="item.id ? item.name : 'Panda'">
                <span class="subtitle-2">
                  <v-icon class="mr-2 pb-1" color="primary">
                    {{ item.id ? 'mdi-folder-outline' : 'mdi-home' }}
                  </v-icon>
                  {{ item.id ? item.name : 'Panda' }}
                </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-icon>mdi-chevron-right</v-icon>

        <button v-if="!selectedFolder" type="button" class="primary--text" @click="handleBackTo(lastBreadcrumbItem)">
          <span class="breadcrumbTexts primary--text">
            {{
              lastBreadcrumbItem.id ? lastBreadcrumbItem.name : 'Panda'
            }}
          </span>
        </button>

        <button v-else type="button" class="primary--text">
          <span class="breadcrumbTexts primary--text">
            {{ selectedFolder.name }}
          </span>
        </button>
      </template>

      <template v-else>
        <small v-for="(item, i) in breadcrumbArray" :key="i">
          <button type="button" class="primary--text" @click="handleBackTo(item)">
            <span class="breadcrumbTexts primary--text">
              {{ item.id ? item.name : 'Panda' }}
              <v-icon v-if="i < breadcrumbArray.length - 1">
                mdi-chevron-right
              </v-icon>
            </span>
          </button>
        </small>

        <small>
          <v-icon v-if="!!selectedFolder">mdi-chevron-right</v-icon>
          <button v-if="!!selectedFolder" type="button" class="primary--text">
            <span class="breadcrumbTexts primary--text">
              {{ selectedFolder.name }}
            </span>
          </button>
        </small>
      </template>

      <!-- list -->
      <div class="list">
        <v-list v-if="toBeSelectedFolders.length" dense>
          <v-list-item-group v-model="selectedFolder">
            <v-list-item v-for="folder in toBeSelectedFolders" :key="folder.id" :value="folder"
              @click="handleRowClick(folder)">
              <v-list-item-icon>
                <v-icon v-text="'mdi-folder-outline'"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="folder.name"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="checkIfHasChildren(folder)" class="my-0 py-0">
                <v-icon color="black">mdi-arrow-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <span v-else class="mt-8">
          {{ $t('message.noFoldersFound') }}
        </span>
      </div>
    </template>

    <template #card-actions>
      <v-card-actions class="pt-8 pb-4 px-0 d-flex">
        <base-btn v-if="false" type="tertiary">
          New folder
        </base-btn>

        <div class="ml-auto">
          <base-btn type="secondary" class="mr-6" @click="close">
            Go back
          </base-btn>
          <base-btn @click="handleSelectFolder">
            Confirm
          </base-btn>
        </div>
      </v-card-actions>
    </template>
  </BaseModal>
</template>

<script>
// external imports
import { mapState } from 'vuex'

// internal imports

// API

// Components

export default {
  name: 'LiveFolderModal',
  components: {
    BaseModal: () => import('@/components/BaseModal.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  props: {
    propsData: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    breadcrumbArray: [
      {
        name: '',
        id: null,
        parent_folder_id: null
      }
    ],
    selectedFolder: null,
    lastFolder: {
      name: '',
      id: null,
      parent_folder_id: null,
    },
    movedItems: [],
    // ...
  }),
  computed: {
    ...mapState('user', {
      folders: 'mainFolders',
    }),
    folder: {
      get() { return this.propsData['folder'] },
      set(value) { this.propsData['folder'] = value }
    },
    isNamesTooBig() {
      let size = 0

      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }

      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }

      return size > 40
    },
    reducedBreadcrumbArray() {
      const arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })

      if (this.selectedFolder) return this.breadcrumbArray

      return arrayMod
    },
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })

      const itemsThatAreFolders = this.movedItems.filter((movedItem) => {
        return movedItem.name
      })

      for (let folderItem of itemsThatAreFolders) {
        const foundItem = selectedFolders.find((item) => {
          return item.id === folderItem.id
        })

        if (foundItem) {
          let filtered = selectedFolders.filter(
            (item) => item.id !== folderItem.id
          )
          selectedFolders = [...filtered]
        }
      }

      return selectedFolders
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
  },
  methods: {
    close() {
      this.$root.$emit('closeLiveFolderModal')
    },

  
    handleBackTo(backToFolder) {
      this.selectedFolder = null
      this.lastFolder = backToFolder

      if (!backToFolder.id) {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        return
      }

      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
        backToFolder.id
      )
        return

      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })

      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    handleRowClick(item) {
      let hasChildren = this.checkIfHasChildren(item)
      if (hasChildren) return this.handleEnterFolder(item)
    },
    checkIfHasChildren(folder) {
      return this.folders.find(
        (item) => item.parent_folder_id === folder.id
      )
    },
    handleEnterFolder(folder) {
      this.lastFolder = folder
      this.breadcrumbArray.push(folder)
    },
    handleSelectFolder() {
      let { id, name } = this.lastFolder

      if (this.selectedFolder) {
        id = this.selectedFolder.id
        name = this.selectedFolder.name
      }

      this.folder.folder_id = id
      this.folder.folder_name = name

      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  max-height: 300px;
  overflow-y: auto;
  margin-top: 16px;
  border: 1px solid var(--v-neutral-lighten2);
  border-radius: 4px;
  padding: 8px;
}

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}
</style>
